import { Button, Col, Row } from "react-bootstrap";
import DetailTopic from "./DetailTopic";
import { Topic } from "../types";
import React from "react";

interface TopicsSectionProps {
    topics: Topic[];
    setTopics: React.Dispatch<React.SetStateAction<Topic[]>>;
    editing: boolean;
    newTopicLabel: string;
    disabled?: boolean;
    onChangeAlertAI?: (value: number | null, index: number) => void;
}

export default function TopicsSection({
    topics,
    setTopics,
    editing,
    newTopicLabel,
    disabled = false,
    onChangeAlertAI,
}: TopicsSectionProps) {
    const handleNewTopic = () => {
        const newTopic: Topic = {
            topicName: "",
            topicId: -2,
        };
        setTopics([...topics, newTopic]);
    };

    const isEditable = editing && !disabled;

    return (
        <>
            {topics.map((_, index) => (
                <Row key={index}>
                    <DetailTopic
                        indexField={index}
                        topics={topics}
                        setTopics={setTopics}
                        editing={isEditable}
                        onChangeAlertAI={(value) => onChangeAlertAI?.(value, index)}
                    />
                </Row>
            ))}

            {editing && (
                <Row style={{ marginTop: "20px" }}>
                    <Col className="text-end">
                        <Button
                            variant="secondary"
                            onClick={handleNewTopic}
                            disabled={disabled}
                        >
                            {newTopicLabel}
                        </Button>
                    </Col>
                </Row>
            )}
        </>
    );
}
